// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1nAsP","title":"AfterBackImages_title__1xl33","images":"AfterBackImages_images__2h1v4"};